import { render, staticRenderFns } from "./SearchResultsList.vue?vue&type=template&id=e4493986&"
import script from "./SearchResultsList.ts?vue&type=script&lang=ts&"
export * from "./SearchResultsList.ts?vue&type=script&lang=ts&"
import style0 from "./SearchResultsList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports